'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  pointer-events: none;\n  button {\n    pointer-events: all;\n    border: 0;\n    background: 0 0;\n    cursor: pointer;\n    font-size: 1.8em;\n    line-height: 1.2em;\n    margin: 0 5px;\n    ', '\n    :hover {\n      color: #000000;\n    }\n    :focus {\n      outline: none;\n    }\n  }\n'], ['\n  display: inline-block;\n  pointer-events: none;\n  button {\n    pointer-events: all;\n    border: 0;\n    background: 0 0;\n    cursor: pointer;\n    font-size: 1.8em;\n    line-height: 1.2em;\n    margin: 0 5px;\n    ', '\n    :hover {\n      color: #000000;\n    }\n    :focus {\n      outline: none;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Dot = _styledComponents2.default.li.attrs({
  children: function children(_ref) {
    var onClick = _ref.onClick;
    return _react2.default.createElement(
      'button',
      { onClick: onClick },
      '\u2022'
    );
  } // eslint-disable-line react/prop-types
})(_templateObject, function (_ref2) {
  var active = _ref2.active;
  return active ? 'color: #000000;' : 'color: #E5E5E5;';
});

exports.default = Dot;


//////////////////
// WEBPACK FOOTER
// ./~/react-styled-carousel/build/components/Dot.js
// module id = 431
// module chunks = 35783957827783